module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/~/core-js/modules/_fails.js
// module id = ../../../../core-js/modules/_fails.js
// module chunks = 0